<template>
  <div 
    class="xit-fb-template node sequence"
    @dblclick.stop="handleClick(node)" 
    :class="[camelCase(node.name), hasData(node), isSelected(node)]" 
  >
    <div class="title">
      <p class="title-content"><i class="fas fa-fill-drip card-start-icon"></i> {{node.lingualName}}</p>
    </div>

    <div class="card-body-handler card_data_body p-0">
      <div class="card-data">
        <p v-if="node.data.name" class="text-center mb-2 postback_title">
          {{ node.data.name }}
        </p>

        <div class="list-group mt-2">
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="node.data.startingTime && node.data.closingTime">         
            <small class="text-muted">{{ start_time }}</small>
            <p class="mb-0"> {{ node.data.startingTime }}</p>
          </span>
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start"  v-if="node.data.startingTime && node.data.closingTime">         
            <small class="text-muted">{{ closing_time }}</small>
            <p class="mb-0"> {{ node.data.closingTime }}</p>
          </span>
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="node.data.timezone">         
            <small class="text-muted">{{ timezone }}</small>
            <p class="mb-0"> {{ node.data.timezone }}</p>
          </span>
          <span class="list-group-item list-group-item-action px-2 py-0 flex-column align-items-start" v-if="node.data.messageTag">         
            <small class="text-muted">{{ message_tag }}</small>
            <p class="mb-0"> {{ node.data.messageTagText }}</p>
          </span>
        </div>
      </div>

      <div class="card-sockets">
        <div class="output text-right float-right" v-for="output in outputs()" :key="output.key" :class="hasConnection(output) ? 'has-connection' : ''">
          <div class="output-title">{{output.name}}</div>
          <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
        </div>
        <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
          <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
          <div class="input-title">{{input.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'

import { lang } from '../../assets/lang'
import { templateComponentMethods } from '../../functions/utils'

export default {
  name: 'SequenceTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  data: () => ({
    start_time: lang.sequence_template_start_time,
    closing_time: lang.sequence_template_closing_time,
    timezone: lang.sequence_template_timezone,
    message_tag: lang.sequence_template_message_tag,
  }),

  methods: {
    ...templateComponentMethods,

    getSelectedLabelTexts(node) {
      const labelIdTextsArray = node.data.labelIdTextsArray || []
      return labelIdTextsArray.join(', ')
    }
  },
}
</script>

<style scoped>
  
  .card-content { font-weight: 400;font-size:12px;}
  .card-sockets { padding: 5px 0 !important;}
  .card-envelope-icon { font-size:13px;}
  .postback_title {
    background-color: #f6f4f4 !important;
    border-radius: 7px;
    padding: 0px 10px;
    text-transform:capitalize;
  }
  .label_ids {
    margin-bottom: 0;
    font-size: 13px;
    color: #6e6e6e;
  }
  .sequence_ids {
    border-top: .5px solid #6e6e6e;
    margin-bottom: 0;
    font-size: 13px;
    color: #6e6e6e;
  }
</style>